// removed by extract-text-webpack-plugin
module.exports = {"map":"map__1IWfb","mapContainer":"mapContainer__zAfSw","disclaimer":"disclaimer__A8ibr","wrapper":"wrapper__1vshp","filterTextWrapper":"filterTextWrapper__2GDLH","filterHighlight":"filterHighlight__1zca5","filterText":"filterText__WUvNS","subtitleWrapper":"subtitleWrapper__1V4FX","titleWrapper":"titleWrapper__B_g1r","list":"list__3dWIz","value":"value__a334h","label":"label__2-_ol","loaderWrapper":"loaderWrapper__3OP09"};


//////////////////
// WEBPACK FOOTER
// ./routes/embedViews/home/recipientCountry/_style.scss
// module id = xQgv
// module chunks = 0